/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { UsageOverviewDto } from '../../models/usage-overview-dto';

export interface AnalyticsOverviewGet$Json$Params {
}

export function analyticsOverviewGet$Json(http: HttpClient, rootUrl: string, params?: AnalyticsOverviewGet$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<UsageOverviewDto>> {
  const rb = new RequestBuilder(rootUrl, analyticsOverviewGet$Json.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<UsageOverviewDto>;
    })
  );
}

analyticsOverviewGet$Json.PATH = '/analytics/overview';
